/** Which screen the app shows, derived from state only (there is no URL router). */
import type { FatalReason } from '../state/connection';
import type { RaceResults, RaceSession } from '../state/race';
import type { ProfileEditorMode } from '../state/ui';

export type ScreenId =
  | 'update'
  | 'replaced'
  | 'login'
  | 'profile'
  | 'game'
  | 'results'
  | 'stats'
  | 'room';

export interface ScreenState {
  fatal: FatalReason | null;
  loggedIn: boolean;
  profileEditor: ProfileEditorMode | null;
  race: RaceSession | null;
  watchingRaceId: string | null;
  results: RaceResults | null;
  dismissedResultsId: string | null;
  /** The player opened the statistics (from the room). */
  statsOpen: boolean;
}

/**
 * Priority, highest first: blocking problems, login, the profile editor, the race (racers
 * always, spectators when they chose to watch), fresh results, the statistics when opened, and
 * the room as the hub.
 */
export function selectScreen(state: ScreenState): ScreenId {
  if (state.fatal === 'version') return 'update';
  if (state.fatal === 'replaced') return 'replaced';
  if (!state.loggedIn) return 'login';
  if (state.profileEditor !== null) return 'profile';
  const race = state.race;
  if (race && (race.role === 'racer' || state.watchingRaceId === race.race.raceId)) return 'game';
  if (!race && state.results && state.results.raceId !== state.dismissedResultsId) return 'results';
  if (state.statsOpen) return 'stats';
  return 'room';
}
